import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allNotifications: [],
  notification: {},
  createNotification: {},
  updateNotification: {},
  deleteNotification: {},
  closeNotification: {},
  allScheduledUpdates: [],
  scheduledUpdate: {},
  createScheduledUpdate: {},
  updateScheduledUpdate: {},
  deleteScheduledUpdate: {},
  changelog: {},
  allChangelogs: [],
  createChangelog: {},
  isLoading: false,
  error: [],
  sseNotifications: [],
  closeNotificationBanner: null,
  changeLogNotification: null,
  closeChangeLogNotification: null,
  deleteChangelog: null,
  allchangeLogFromID: [],
};

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    start: (state) => {
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSSENotifications: (state, action) => {
      state.sseNotifications = action.payload;
      state.isLoading = false;
    },
    setAllNotifications: (state, action) => {
      state.allNotifications = action.payload;
      state.isLoading = false;
    },
    setCreateNotification: (state, action) => {
      state.createNotification = action.payload;
      state.isLoading = false;
    },
    setNotification: (state, action) => {
      state.notification = action.payload;
      state.isLoading = false;
    },
    setUpdateNotification: (state, action) => {
      state.updateNotification = action.payload;
      state.isLoading = false;
    },
    setDeleteNotification: (state, action) => {
      state.deleteNotification = action.payload;
      state.isLoading = false;
    },
    setCloseNotification: (state, action) => {
      state.closeNotification = action.payload;
      state.isLoading = false;
    },
    setCloseNotificationBanner: (state, action) => {
      state.closeNotificationBanner = action.payload;
      state.isLoading = false;
    },
    setChangeLogNotification: (state, action) => {
      state.changeLogNotification = action.payload;
      state.isLoading = false;
    },
    setCloseChangeLogNotification: (state, action) => {
      state.closeChangeLogNotification = action.payload;
      state.isLoading = false;
    },
    setAllScheduledUpdates: (state, action) => {
      state.allScheduledUpdates = action.payload;
      state.isLoading = false;
    },
    setAllChangeLogFromID: (state, action) => {
      state.allchangeLogFromID = action.payload;
      state.isLoading = false;
    },
    setCreateChangeLog: (state, action) => {
      state.createChangelog = action.payload;
      state.isLoading = false;
    },
    setCreateScheduledUpdate: (state, action) => {
      state.createScheduledUpdate = action.payload;
      state.isLoading = false;
    },
    setUpdateScheduledUpdate: (state, action) => {
      state.updateScheduledUpdate = action.payload;
      state.isLoading = false;
    },
    setDeleteScheduledUpdate: (state, action) => {
      state.deleteScheduledUpdate = action.payload;
      state.isLoading = false;
    },
    setScheduledUpdate: (state, action) => {
      state.scheduledUpdate = action.payload;
      state.isLoading = false;
    },
    setChangeLog: (state, action) => {
      state.changelog = action.payload;
      state.isLoading = false;
    },
    setDeleteChangeLog: (state, action) => {
      state.deleteChangelog = action.payload;
      state.isLoading = false;
    },
    setResetNotification: () => {
      return initialState;
    },
  },
});

// Export actions and reducer
export const {
  start,
  setReducerError,
  setSSENotifications,
  setAllNotifications,
  setCreateNotification,
  setNotification,
  setUpdateNotification,
  setDeleteNotification,
  setCloseNotification,
  setCloseNotificationBanner,
  setChangeLogNotification,
  setCloseChangeLogNotification,
  setAllScheduledUpdates,
  setAllChangeLogFromID,
  setCreateChangeLog,
  setCreateScheduledUpdate,
  setUpdateScheduledUpdate,
  setDeleteScheduledUpdate,
  setScheduledUpdate,
  setChangeLog,
  setDeleteChangeLog,
  setResetNotification,
} = notificationSlice.actions;

export default notificationSlice.reducer;
